<template>
  <a-card :bordered='false'>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :key="1" tab="经销商后台首页设置">
        <pageSetUp ref="pageSetUp"></pageSetUp>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="经销商常用功能设置">
        <dealerUsed></dealerUsed>
      </a-tab-pane>
      <a-tab-pane :key="3" tab="登录页设置">
        <loginSet></loginSet>
      </a-tab-pane>
      <a-tab-pane :key="4" tab="系统配置">
        <systemSet></systemSet>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
  import { ref } from "vue";
  import pageSetUp from "./components/page_setup"
  import loginSet from "./components/loginSet"
  import dealerUsed from './dealerUsed/index'
  import systemSet from "./components/systemSet"
  export default {
    components: { pageSetUp, loginSet, dealerUsed, systemSet },
    setup() {
      const activeKey = ref(1)
      return {
        activeKey
      };
    },
  };
</script>